import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import '../../assets/css/legacyCMSStyles.css';

import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';


// Engage Actions 
import { getAllCLCommunities, getCLCommunityById } from '../../actions/communityActions';
import { LogoutProccess } from '../../actions/authActions';
import LegacyAppBar from '../ui/LegacyAppBar';

import {
    UPDATE_COMMUNITY_SUCCESS
} from '../../constants/communityConstants';
import { UPDATE_DEVICE_SUCCESS } from "../../constants/devicesConstants";

//Views
import ManagementCommunity from './ManagementCommunity';
import ManagementIntegration from './ManagementIntegration';
import ManagementDevice from './ManagementDevice';
import ManagementDeviceDetails from './ManagementDeviceDetails';
import ManagementTile from './ManagementTile';
import ManagementDiagnosticReport from './ManagementDiagnosticReport';


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export class ManagementBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            actualCommunityId: undefined,
            //Device details
            openDeviceDetails: false,
            deviceSelectedForDetails: {},
            selectedDevices: [],
            //tabs
            tabSelected: 0,//TODO return to 0
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //superUserCombo
            openCommunityCombo: false
        }

    };

    componentDidUpdate() {

        if (this.props.communityData || (this.props.communityData && this.props.communityData.length > 0)) {
            const communitySelected = this.props.communityData.find(community => community.communityId === localStorage.getItem('communityId'));

            if (this.state.superUserCommunitySelected !== undefined && this.state.superUserCommunitySelected.communityId === communitySelected.communityId)
                return

            if (communitySelected !== undefined && this.state.superUserCommunitySelected === undefined) {
                this.setState({ superUserCommunitySelected: communitySelected });
            }
        }
    }

    componentDidMount() {

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0)) {
            this.GetAllCommunities();
        }
    }


    //#region methods

    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };

    handleCommunityChange = () => {
        const id = localStorage.getItem('communityId');
        const communitySelected = this.props.communityData.find(community => community.communityId === localStorage.getItem('communityId'));
        this.setState({ communityId: id, superUserCommunitySelected: communitySelected });
    }

    GetAllCommunities = () => {
        if (localStorage.getItem('superAdmin') === "false")
            this.props.getCLCommunityById(localStorage.getItem('communityId'))
        else
            this.props.getAllCLCommunities()
    };

    logout = () => {
        this.props.LogoutProccess();
    }


    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }

    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet });
        } catch (err) { }
    };

    handleTabChange = (event, newValue) => {
        if (newValue < -1)
            return undefined

        this.setState({ tabSelected: newValue })
    };

    handlerSave = () => {
        var link = document.getElementById('save_btn')
        link.click()
    };

    handlerSaveIntegration = () => {
        var link = document.getElementById('save_integration_btn')
        link.click()
    };

    handlerSaveTiles = () => {
        var link = document.getElementById('save_tiles_btn')
        link.click()
    };

    handlerExport = () => {
        var link = document.getElementById('export_diagnostic_btn')
        link.click()
    };

    handlerRegister = () => {
        var link = document.getElementById('Register_Device_Btn')
        link.click()
    };

    handlerExportDevice = () => {
        var link = document.getElementById('Export_Device_Btn')
        link.click()
    };

    handlerSaveDevice = () => {
        var link = document.getElementById('save_device_Btn')
        link.click()
    };

    handlerMessage = () => {
        if (this.state.openDeviceDetails || this.state.selectedDevices.length) {
            var link = document.getElementById('Message_Device_Btn')
            link.click()
        }
    };

    handlerReboot = () => {
        if (this.state.openDeviceDetails || this.state.selectedDevices.length) {
            var link = document.getElementById('Reboot_Device_Btn')
            link.click()
        }
    };

    handlerUnregister = () => {
        if (this.state.openDeviceDetails || this.state.selectedDevices.length) {
            var link = document.getElementById('Unregister_Device_Btn')
            link.click()
        }
    };

    deviceSelectedHandler = (openDeviceDetails, deviceSelectedForDetails) => {
        this.setState({ openDeviceDetails: openDeviceDetails, deviceSelectedForDetails: deviceSelectedForDetails });
    }

    closeDetails = () => {
        try {
            this.setState({ openDeviceDetails: false, deviceSelectedForDetails: undefined, selectedDevices: [] })
        } catch (err) {
            return undefined;
        }
    }

    handleIsSelectedDevices = (selectedDevices = []) => {
        this.setState({ selectedDevices: selectedDevices });
    }


    //#endregion Methods

    //#region Components

    eHubTabComponent = () => {
        const headers = ['Community', 'Integrations', 'eHub Devices', 'Tile Customizations'];

        return (
            <Grid item container alignContent='flex-start'>
                <Grid item container alignContent='flex-end'>
                    <Grid item container>
                        <this.TabsHeaders headers={headers} />
                    </Grid>
                </Grid>
                <Grid item container style={{ height: '90%' }}>
                    <this.TabsContent />
                </Grid>
            </Grid>
        )
    }

    TabsHeaders = ({ headers }) => {
        if (!headers || headers.length === 0)
            return undefined;

        return (
            <Grid item container style={{ height: '100%' }}>
                <Tabs
                    value={this.state.tabSelected}
                    onChange={this.handleTabChange}
                    aria-label="full width tabs repairs"
                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                    className='LTabHeaderContainer'
                >
                    <Tab label={`Community`} className={(this.state.tabSelected === 0) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Integrations`} className={(this.state.tabSelected === 1) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`eHub Devices`} className={(this.state.tabSelected === 2) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Tile Customizations`} className={(this.state.tabSelected === 3) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Diagnostic Report`} className={(this.state.tabSelected === 4) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                </Tabs>
            </Grid>
        )
    }

    TabsContent = () => {

        return (
            <Grid item container className="LTabContentContainer" >
                <SwipeableViews
                    axis={'x'}
                    index={this.state.tabSelected}
                    onChangeIndex={this.handleChangeIndex}
                    style={{ width: '100%' }}
                >
                    <TabPanel value={0} index={0} dir={'x'} style={{ color: 'black' }}>
                        <ManagementCommunity
                            communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined}
                            name={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected.name : ''}
                        />
                    </TabPanel>
                    <TabPanel value={1} index={1} dir={'x'} style={{ color: 'black' }}>
                        <ManagementIntegration communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined} />
                    </TabPanel>
                    <TabPanel value={2} index={2} dir={'x'} style={{ color: 'black' }}>
                        <ManagementDevice
                            communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined}
                            isSelectedDevices={(selectedDevices) => this.handleIsSelectedDevices(selectedDevices)}
                            onDeviceSelected={this.deviceSelectedHandler}
                        />
                    </TabPanel>
                    <TabPanel value={3} index={3} dir={'x'} style={{ color: 'black' }}>
                        <ManagementTile
                            communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined}
                        />
                    </TabPanel>
                    <TabPanel value={4} index={4} dir={'x'} style={{ color: 'black' }}>
                        <ManagementDiagnosticReport
                            communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined}
                        />
                    </TabPanel>
                </SwipeableViews>
            </Grid>
        )
    }

    //#endregion

    render() {

        if (this.props.isCommunitySuccess.success && this.props.isCommunitySuccess.type === UPDATE_COMMUNITY_SUCCESS) {
            if (localStorage.getItem('superAdmin') === "false")
                this.props.getCLCommunityById(localStorage.getItem('communityId'));
            else
                this.props.getAllCLCommunities();
        }

        if (this.props.deviceReducerType === UPDATE_DEVICE_SUCCESS && this.state.openDeviceDetails) {
            this.closeDetails();
        }

        return (
            <Grid item container className={this.state.openDeviceDetails ? 'LGeneralBackgroundWhite' : 'LGeneralBackground'}>
                <Grid item container style={{ height: '20vh' }}>
                    <LegacyAppBar
                        dispatchActions={this.handleCommunityChange}
                        superUserVisible={localStorage.getItem('superAdmin') === "true" && !this.state.openDeviceDetails ? true : false}
                        title={'eHub Management'}
                    />
                    <Grid item container className='LHeadersButtons' style={{ paddingLeft: '20px' }}>
                        {
                            this.state.tabSelected === 0 ?
                                <Grid item
                                    id='Save_Community_Btn'
                                    className="appbtnBarButtonv2 LButtonStyle"
                                    onClick={this.handlerSave}>
                                    Save
                                </Grid>
                                : this.state.tabSelected === 1 ?
                                    <Grid item
                                        id='Save_Community_Btn'
                                        className="appbtnBarButtonv2 LButtonStyle"
                                        onClick={this.handlerSaveIntegration}>
                                        Save
                                    </Grid>
                                    : this.state.tabSelected === 2 ?
                                        <>
                                            {
                                                (this.state.openDeviceDetails && this.state.deviceSelectedForDetails) ?
                                                    <>
                                                        <Grid item style={{ display: 'flex', cursor: 'pointer' }} onClick={() => this.closeDetails()}>
                                                            <Grid item style={{ paddingLeft: '10px', paddingRight: '20px', display: 'flex' }}>
                                                                <img
                                                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                                    alt='return'
                                                                    className="LBackArrow"
                                                                />
                                                            </Grid>
                                                            {/*<Grid item style={{ paddingLeft: '10px', paddingRight: '10px', alignSelf: 'center', color: '#105a88', fontSize: '22px', fontFamily: 'Gotham-Bold' }}>Devices</Grid>*/}
                                                        </Grid>
                                                        <Grid item
                                                            id='Save_Device_Btn'
                                                            className="appbtnBarButtonv2 LButtonStyle"
                                                            onClick={this.handlerSaveDevice}>
                                                            Save
                                                        </Grid>
                                                    </>
                                                    :
                                                    <>

                                                        <Grid item
                                                            id='Register_Btn'
                                                            className="appbtnBarButtonv2 LButtonStyle"
                                                            onClick={this.handlerRegister}>
                                                            Register
                                                        </Grid>

                                                        <Grid item
                                                            id='Export_Btn'
                                                            className="appbtnBarButtonv2 LButtonStyle LPurpleButton"
                                                            onClick={this.handlerExportDevice}>
                                                            Export Devices
                                                        </Grid>
                                                    </>
                                            }
                                            <Grid item
                                                id='Message_Btn'
                                                className={this.state.openDeviceDetails || this.state.selectedDevices.length > 0 ? "appbtnBarButtonv2 LButtonStyle LBlueGrayButton" : "appbtnBarButtonv2 LButtonStyle LBlueGrayButton disabledSkybluebtn-engage"}
                                                onClick={this.handlerMessage}>
                                                Message
                                            </Grid>
                                            <Grid item
                                                id='Reboot_Btn'
                                                className={this.state.openDeviceDetails || this.state.selectedDevices.length > 0 ? "appbtnBarButtonv2 LButtonStyle LBorderRedButton" : "appbtnBarButtonv2 LButtonStyle LBorderRedButton disabledSkybluebtn-engage"}
                                                onClick={this.handlerReboot}>
                                                Reboot
                                            </Grid>
                                            <Grid item
                                                id='Unregister_Btn'
                                                className={this.state.openDeviceDetails || this.state.selectedDevices.length > 0 ? "appbtnBarButtonv2 LButtonStyle LRedButton" : "appbtnBarButtonv2 LButtonStyle LRedButton disabledSkybluebtn-engage"}
                                                onClick={this.handlerUnregister}>
                                                Unregister
                                            </Grid>
                                        </>
                                        : this.state.tabSelected === 3 ?
                                            <Grid item
                                                id='Save_Tiles_Btn'
                                                className="appbtnBarButtonv2 LButtonStyle"
                                                onClick={this.handlerSaveTiles}>
                                                Save
                                            </Grid>
                                            : this.state.tabSelected === 4 ?
                                                <Grid item
                                                    id='Export_Diagnostic_Report'
                                                    className="appbtnBarButtonv2 LButtonStyle"
                                                    onClick={this.handlerExport}>
                                                    Export To CSV
                                                </Grid>
                                                : ""
                        }
                    </Grid>
                </Grid>
                <Grid item container style={{ minHeight: '80vh' }}>
                    {
                        this.state.openDeviceDetails ?
                            <ManagementDeviceDetails
                                deviceSelected={this.state.deviceSelectedForDetails}
                                communityInfo={this.state.superUserCommunitySelected}
                                onCloseDetials={this.closeDetails} />
                            :
                            <this.eHubTabComponent />
                    }
                </Grid>
            </Grid>
        )
    }
}


function mapStateToProps(state, dispatch) {
    const isSuperAdmin = (state.authReducer && state.authReducer.superAdmin) ? state.authReducer.superAdmin : undefined;
    const givenName = (state.authReducer && state.authReducer.givenName) ? state.authReducer.givenName : undefined;
    const familyName = (state.authReducer && state.authReducer.familyName) ? state.authReducer.familyName : undefined;

    let communityData = (state.communityReducer && state.communityReducer.communityData && Array.isArray(state.communityReducer.communityData) && state.communityReducer.communityData.length > 0) ?
        state.communityReducer.communityData.map(item => (
            {
                _id: item._id,
                name: item.communityName,
                communityId: item.communityId,
                address: item.communityAddress + ', ' + item.communityCity + ', ' + item.communityState + ' ' + item.communityZipcode,
                logo: item.communityLogoUrl,
                logsRecipient: item.logsRecipient,
                isVoiceAvailable: item.isVoiceAvailable,
                entertain360: item.entertain360,
                coroHealth: item.coroHealth,
                worxHub: item.worxHub,
                tels: item.tels,
            }
        )) : [];

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        isSuperAdmin: isSuperAdmin,
        givenName: givenName,
        familyName: familyName,
        communityData: communityData,
        isCommunitySuccess: state.communityReducer,
        deviceReducerType: (state.deviceReducer && state.deviceReducer.type) ? state.deviceReducer.type : ""
    }
};

export default connect(mapStateToProps, { getAllCLCommunities, getCLCommunityById, LogoutProccess })(ManagementBase)